/** Convert a file-router key into a route path, shared with route benchmarks. */
export function pageRoutePath(source: string): string {
  return source
    .replace(/\.\.\/pages|index|\.tsx$/g, "")
    .replace(/\[\.{3}.+\]/, "*")
    .replace(/\[(.[^\]]+)\]/g, ":$1")
    .replace(/(.+)\/$/g, "$1")
    .replace(/^\/(.+)/g, "$1");
}
